import ApplicationRecord from '@/models/application_record'

import { Model } from 'spraypaint'

@Model()
export default class TaskList extends ApplicationRecord {
  static jsonapiType = 'task_lists'
}
